// extracted by mini-css-extract-plugin
export default {"container":"NewsPage_container__5OTvi","main":"NewsPage_main__72L1G","sidebar":"NewsPage_sidebar__RlN1Z","rightbar":"NewsPage_rightbar__TUuYh","feed":"NewsPage_feed__13YSH"};